import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-we-are-unique',
  templateUrl: './why-we-are-unique.component.html',
  styleUrls: ['./why-we-are-unique.component.css']
})
export class WhyWeAreUniqueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
